import React, { useEffect, useState } from 'react';
import "../Css/SuccessPage.css";
import { PiSealCheckFill } from "react-icons/pi";
import { useCartContext } from '../context/addToCart';
import { Link, useParams } from 'react-router-dom';
import deliverymanriding from "../Images/delivery-man-riding.png";
import { get } from '../services/ApiRouting';
import moment from 'moment';
import { FcCancel } from 'react-icons/fc';
import axios from 'axios';

const FailedPage = () => {
    const { cartValue, setCartCount, setCartValue } = useCartContext();
    const profileData = JSON.parse(localStorage.getItem('profile'));
    const { order_id } = useParams();

    const [orderProduct, setOrderProduct] = useState(null);
    const [mainProductData, setMainProductData] = useState(null)
    const fetchData = async () => {
        try {
            const response = await axios.get(`https://api.woodsy.co.in/api/wood-orders/fetch?order_id=${order_id}`);
            console.log("response",response?.data?.orders[0])
            setMainProductData(response?.data?.orders[0])
            console.log("setMainProductData",response?.data?.orders[0])
            // setAddress(response.orders[0].address)
            setOrderProduct(response?.data?.orders[0].products);
            console.log("responce", response)
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    useEffect(() => {
        fetchData();
    }, [order_id]);

    // Calculate total and tax
    const calculateTotal = () => {
        if (!orderProduct || orderProduct.length === 0) return { total: 0, tax: 0 };
        const total = orderProduct.reduce((acc, item) => {
            return acc + item.product_price * item.product_qty;
        }, 0);
    
        const tax = total * 0.18; // 18% tax
        return { total, tax };
    };

    const { total, tax } = calculateTotal();

    const roundedBasePrice = Math.round(mainProductData?.subtotal / 1.18); 
    const totaltax = Math.round(mainProductData?.subtotal - roundedBasePrice);

    return (
        <>
            <section className='SuccessPage-Section-con'>
                <div className='container'>
                    <div className='SuccessPage-Section'>
                        <div className='SuccessPage-Section-Details-con'>
                            <div className='order-Success-con'>
                                <div className='order-Success-con-icons'>
                                    <FcCancel />
                                    <h2>Order Failed</h2>
                                    <p>We regret to inform you that there has been an issue with your order at 1Five , and it could not be successfully confirmed. We sincerely apologize for any inconvenience this may have caused. Our team is actively working to address the issue and will provide further assistance shortly.</p>
                                </div>
                                <div className='Order-Success-Details-con-Main'>
                                    <div className='Order-Success-Details-con-Main-head'>
                                        <div className='Order-Success-List-head'>
                                            <h3>Order Id : - <span>{mainProductData?.order_id}</span></h3>
                                        </div>
                                        <div className='Order-Success-List-head'>
                                            <h3>Ordered on : - <span>
                                                {mainProductData?.created_at
                                                    ? new Date(mainProductData?.created_at).toLocaleString()
                                                    : "N/A"}
                                            </span></h3>
                                        </div>
                                    </div>
                                    {/* <div className='Order-Success-Details-con'>
                                        <div className='Order-Success-Details-add'>
                                            <h1>delivering to :</h1>
                                            <div className='Order-Success-Details-name-contact'>
                                                <h2>
                                                    {orderProduct && orderProduct.username}
                                                </h2>
                                                <span>
                                                    |
                                                </span>
                                                <h2>
                                                    {orderProduct && orderProduct.user_phone}
                                                </h2>
                                            </div>
                                            <div className='Order-Success-Details-address'>
                                                <p>Office No 301, MOHID HEIGHTS, opposite Mahada, signal, near kokilaben hospital, Suresh Nagar, Andheri West, Mumbai, Maharashtra 400053,</p>
                                            </div>
                                        </div>
                                        <div className='Order-Success-Details-Image-con'>
                                            <img src={deliverymanriding} alt="" />
                                        </div>
                                    </div> */}
                                </div>

                                <div className='Order-Success-List-con'>
                                    <div className="Order-Success-List">
                                        <div className='Product-addedCart-Side-Bar Successpage-Product-addedCart-Side-Bar' id="style-4">
                                        {
                                                orderProduct && orderProduct.map((elem, index) => {
                                                const { details, images, size, price, qty,main_category,brand,sub_category,product } = elem
                                                console.log("product",product)
                                                    return (
                                                        <div key={index} className='Product-addedCart-Side-details'>
                                                            <div className='Product-addedCart-Image-con'>
                                                                <div className='Product-addedCart-Image'>
                                                                    {product?.images && product?.images && (
                                                                                <img src={`https://api.woodsy.co.in/storage/${product?.images[1]?.image1}`} alt={brand?.name} />
                                                                            )}
                                                                </div>
                                                            </div>
                                                            <div className='Product-details-addedCart-price-name SuccessPageprice'>
                                                                <div className='Product-details-addedCart-price'>
                                                                    <h2>{brand?.name}</h2>
                                                                        <h2>{main_category?.name}</h2>
                                                                        <h2>{sub_category?.name}</h2>
                                                                        <h3>Qty: <span>{qty}</span></h3>
                                                                        <h3>Price: <span>{price}</span></h3>
                                                                        <h3>Size: <span>{size}</span></h3>
                                                                </div>
                                                                <h2>{price}/- Rs</h2>
                                                            </div>
                                                        </div>
                                                    );
                                                })
                                            }
                                        </div>
                                        <div className='Product-details-Addedcart-total-con'>
                                        <div className='Product-details-Addedcart-total order-successpage-product-detail-final'>
                                                <div className='Product-details-Addedcart-total-title'>
                                                    <h4>Subtotal:</h4>
                                                    <h4>Tax (18%):</h4>
                                                    {/* <h4>BasePrice:</h4> */}
                                                    <h4>Total:</h4>
                                                </div>
                                                <div className='Product-details-Addedcart-total-Amount'>
                                                    <h5>{mainProductData?.gross_amount} /- Rs</h5>
                                                    <h5>{mainProductData?.tax_amount} /- Rs</h5>
                                                    <h5>{mainProductData?.total_amount} /- Rs</h5>
                                                </div>
                                            </div>
                                        </div>
                                        <div className='order-success-page-btn-con'>
                                            <Link to="/">
                                                <button>
                                                    Back to home
                                                </button>
                                            </Link>
                                            <Link to="/product">
                                                <button>
                                                    Continue Shopping
                                                </button>
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}

export default FailedPage;
